module.exports = __webpack_public_path__ + "media/images/sort_desc-10b419d15f506a51624848a755df07e8.png";